import { combineReducers } from 'redux'

import settings from './ducks/settings'
import presents from './ducks/presents'
import honeymoon from './ducks/honeymoon'
import messages from './ducks/messages'
import cart from './ducks/cart'
import page from './ducks/page'

export default combineReducers({
  settings,
  presents,
  cart,
  honeymoon,
  messages,
  currentPage: page,
})
